import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './assets/locales/en/translation.json';

const resources = {
    en: {
        translation: translationEN,
    },
};

i18n.use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        supportedLngs: ['en'],

        debug: import.meta.env.DEV,

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
